import React, { useState, useRef, useEffect, useMemo } from 'react';
import { UserFlowTypes } from '../UserFlowTypes';
import ReactTooltip from 'react-tooltip';
import { Icon } from '../../../utilities/icomoon-css';
import { accountSectionConfig } from '../components/accountConfig';

interface Props {
  data: UserFlowTypes.TReservation[];
  id: string;
}

export const RenderReservationUnitTypes: React.FC<Props> = ({
  data = [],
  id,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState<number | null>(null);

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
  }, []);

  const getTextWidth = (text: string) => {
    const canvas = document.createElement('canvas');
    const context: any = canvas.getContext('2d');
    context.font = getComputedStyle(document.body).fontSize + ' Montserrat';
    return context.measureText(text).width;
  };

  const visibleLabels = useMemo(() => {
    let totalWidth = 0;
    let visibleCount = 0;

    for (let i = 0; i < data.length; i++) {
      const label =
        (data[i].unit_label
          ? `${data[i].unit_type_description} (${data[i].unit_label})`
          : data[i].unit_type_description) || '';
      const labelWidth = getTextWidth(label);
      totalWidth += labelWidth;

      if (containerWidth && totalWidth + 120 <= containerWidth) {
        visibleCount++;
      }
    }

    return data.slice(0, visibleCount);
  }, [data, containerWidth]);

  const getTooltipContent = useMemo(
    () =>
      data
        .filter(item => !visibleLabels.includes(item))
        .map((item, index) => (
          <div key={index} className="reservationUnitsLabel tooltipEnclosure">
            {item.unit_label
              ? `${item.unit_type_description} (${item.unit_label})`
              : item.unit_type_description}
            {index < data.length - 1 && <br />}
          </div>
        )),
    [data, visibleLabels]
  );

  return (
    <div className="reservationEnclosure">
      <div className="iconWrapper">
        <Icon
          name={'tfw-website-calendar-cp'}
          size={24}
          title={'tfw-website-calendar-cp'}
        />
      </div>
      <div>
        <h5 className="reservationLabel">
          {accountSectionConfig.reservedUnitTypes}:
        </h5>
        <div
          ref={containerRef}
          className="reservationUnitsLabel reservationUnitsList"
        >
          <p>
            {visibleLabels.map((item, index) => (
              <span key={index}>
                {item.unit_label
                  ? `${item.unit_type_description} (${item.unit_label})`
                  : item.unit_type_description}
                {index < visibleLabels.length - 1 && ', '}
              </span>
            ))}
            {data.length > visibleLabels.length && (
              <span
                className="tooltipLink"
                style={{ cursor: 'pointer' }}
                data-tip
                data-for={`remainingUnitTypes${id}`}
                data-event="click focus"
              >
                +{data.length - visibleLabels.length} more
              </span>
            )}
            <ReactTooltip
              id={`remainingUnitTypes${id}`}
              globalEventOff="click"
              effect="solid"
              place="bottom"
              type="light"
            >
              {getTooltipContent}
            </ReactTooltip>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RenderReservationUnitTypes;
